/**
 * How to Use section: lazy-load images + carousel drag-to-scroll.
 */
(function () {
  function initLazyLoad() {
    var sections = document.querySelectorAll('[data-how-to-use-lazy-section]');
    sections.forEach(function (section) {
      var images = section.querySelectorAll('img[data-how-to-use-lazy]');
      if (images.length === 0) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var img = entry.target;
            var src = img.getAttribute('data-src');
            if (src && !img.dataset.loaded) {
              img.src = src;
              img.dataset.loaded = '1';
              img.removeAttribute('data-src');
            }
            observer.unobserve(img);
          });
        },
        { rootMargin: '100px 0px', threshold: 0.01 }
      );

      images.forEach(function (img) {
        if (img.getAttribute('data-src')) {
          observer.observe(img);
        }
      });
    });
  }

  function initCarouselDrag() {
    var wrappers = document.querySelectorAll('.how-to-use--carousel .how-to-use__steps-wrapper');
    wrappers.forEach(function (wrapper) {
      var isDown = false;
      var startX;
      var scrollLeft;

      wrapper.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true;
        wrapper.classList.add('how-to-use__steps-wrapper--dragging');
        startX = e.pageX - wrapper.offsetLeft;
        scrollLeft = wrapper.scrollLeft;
      });

      wrapper.addEventListener('mouseleave', function () {
        isDown = false;
        wrapper.classList.remove('how-to-use__steps-wrapper--dragging');
      });

      wrapper.addEventListener('mouseup', function () {
        isDown = false;
        wrapper.classList.remove('how-to-use__steps-wrapper--dragging');
      });

      wrapper.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - wrapper.offsetLeft;
        var walk = (x - startX) * 1.2;
        wrapper.scrollLeft = scrollLeft - walk;
      });
    });
  }

  function init() {
    initLazyLoad();
    initCarouselDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
